import { type GA4 } from "./interfaces";

/**
 * To measure how many times item details are viewed, send a view_item event whenever a user views an item’s details screen.
 * @param payload
 */
export async function sendViewItemDatalayerEvent(payload: GA4.ViewItemPayload) {
  window.gtag({ ecommerce: null });

  window.gtag({
    event: "view_item",
    ecommerce: payload,
  });
}
